import "./style.css";

export default class CookieBanner {
  static selector = ".cookie-banner";

  constructor(block) {
    this.block = block;

    const cookiePolicy = window.localStorage.getItem("cookiePolicy");

    if (cookiePolicy) {
      this.hideBanner();
    } else {
      const button = block.querySelector("button");
      button.addEventListener("click", this.onClick);
    }
  }

  hideBanner = () => {
    this.block.classList.toggle("no-display", true);
  };

  onClick = () => {
    window.localStorage.setItem("cookiePolicy", "1");
    this.hideBanner();
  };
}
